import React from 'react';
import Radium from 'radium';

import 'css/loader.css';

class Loader extends React.Component {

	render() {
		const style = this.props.style;

		//by default there is a shining effect but can be removed by noEffect attribute
		const noEffect = this.props.noEffect === true;

		let className = 'loaderBox';

		if(this.props.className)
			className += ' '+this.props.className;

		return <div style={style} className={className}>
						{ 
							!noEffect && 
							<i className='loader'></i>
						}
				</div>
	}
};

Loader = Radium(Loader);
export default Loader;


// WEBPACK FOOTER //
// ./src/views/Loader.js